<template>
    <app-admin-layout>
        <Head>
            <title>Admin User</title>
        </Head>

        <div class="admin-user">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <card>
                            <card-header>
                                <card-overline>
                                    Benutzer
                                    <Link :href="this.$$route('admin-user.create')"><badge>Neuen Benutzer anlegen</badge></Link>
                                </card-overline>

                            </card-header>
                            <card-content>
                                <table class="table table--stripped table--card">
                                    <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Benutzergruppe</th>
                                        <th>Email</th>
                                        <th>Status</th>
                                        <th>Beschreibung</th>
                                        <th class="small"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="admin in adminUserTable" :key="admin.index">
                                        <td>{{ admin.name }}</td>
                                        <td>{{ admin.admin_user_group_string }}</td>
                                        <td>{{ admin.email }}</td>
                                        <td>{{ admin.active_string }}</td>
                                        <td>{{ admin.comment }}</td>
                                        <td>
                                            <form-link-button :route="this.$$route('admin-user.edit', {'adminUser': admin.id})" icon="pen-edit" dense="true" />
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </card-content>
                        </card>
                    </div>
                </div>
                <div class="row">
                    <div class="col">

                    </div>
                </div>
            </div>
        </div>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormLinkButton from '@partfactory/Shared/Form/FormLinkButton';
import Badge from '@partfactory/Shared/Elements/Badge';

export default {
    name: 'AdminUserIndex',
    components: {Badge, FormLinkButton, CardContent, CardOverline, CardHeader, Card, AppAdminLayout},
    props: {
        adminUser: Object,
    },
    computed: {
        adminUserTable() {
            let adminUsers = this.adminUser;

            adminUsers.forEach(user => {
                user.active_string = user.active ? 'aktiv' : 'inaktiv';
                const adminUserGroup = this.$page.props.adminUserGroups.filter(group => {
                    return group['value'] === String(user.admin_user_group);
                });

                user.admin_user_group_string = adminUserGroup?.[0]?.text;
            });

            return adminUsers;
        },
    },
    methods: {

    }
};
</script>
